const STORAGE_KEY = "header_account_login_redirect";

/**
 * @param {string | null | undefined} path
 */
export function setHeaderAccountLoginRedirect(path) {
  if (typeof window === "undefined") {
    return;
  }
  if (path && String(path).startsWith("/account")) {
    sessionStorage.setItem(STORAGE_KEY, path);
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}

/** @returns {string | null} */
export function getHeaderAccountLoginRedirect() {
  if (typeof window === "undefined") {
    return null;
  }
  const path = sessionStorage.getItem(STORAGE_KEY);
  return path && path.startsWith("/account") ? path : null;
}

/** @returns {string | null} */
export function consumeHeaderAccountLoginRedirect() {
  const path = getHeaderAccountLoginRedirect();
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(STORAGE_KEY);
  }
  return path;
}

/** */
export function clearHeaderAccountLoginRedirect() {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
